import wx from 'weixin-js-sdk'
import request from '@/utils/request'
import { getUrlKey } from '@/utils/index' // 获取url参数

function GetJsSign(data) {
  return request({
    url: 'wechat/Base/GetJsSign',
    method: 'GET',
    params: data
  })
}

export default {
  init(apiList = [], debug) {
    const url = window.location.href.split('//')[1]
    const wxKey = getUrlKey('wxKey')
    return new Promise((resolve, reject) => {
      GetJsSign({
        WxKey: wxKey,
        url: url.split('#')[0]
      }).then(res => {
        if (res.data.code === 200) {
          var data = res.data.data
          wx.config({
            debug: debug,
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.noncestr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名
            jsApiList: apiList
          })
          wx.ready(() => {
            wx.checkJsApi({
              jsApiList: apiList,
              success: function(apiRes) {
                resolve(wx, apiRes)
              },
              fail: function(err) {
                reject(err)
              }
            })
          })
        } else {
          reject(res)
        }
      })
    })
  }
}
